import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChange, SimpleChanges, ChangeDetectorRef} from '@angular/core';
import {Share} from '../model/share';
import {DataSource} from '@angular/cdk/table';
import {BehaviorSubject, Observable, of} from 'rxjs';
import { AccessLogService } from '../service/access-log.service';
import { AccessLog } from '../model/accessLog';
import { ControlDevice } from '../model/controlDevice';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Log } from '../util/log';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit, AfterViewInit {
  
  fromFormControl : FormControl;
  toFormControl : FormControl;
  fromDate: Date;
  toDate: Date;

  @Input() device: ControlDevice;
  @ViewChild('accessLogsTable', { static: true }) table;
  @ViewChild('accesslogloader', { static: true }) loader;
  @Output() selected = new EventEmitter<AccessLog>();

  selectedAccessLog: AccessLog;

  isLoading: boolean;
  dataSource: AccessLogSource;
  displayedColumns: string[] = ['state', 'user', 'accessName', 'date'];

  error: boolean = false;
  errorMessage: String = "";

  constructor(private accessLogService: AccessLogService, private cdRef:ChangeDetectorRef) {

    this.fromDate = new Date();
    this.fromDate.setMinutes(0); 
    this.fromDate.setHours(0);
    this.fromDate.setSeconds(0);

    this.toDate = new Date();
    this.toDate.setMinutes(59); 
    this.toDate.setHours(24);
    this.toDate.setSeconds(59);

    this.fromFormControl = new FormControl(this.fromDate);
    this.toFormControl =  new FormControl(this.toDate);
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loader.showLoading();
      this.isLoading = true;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    
    const device: SimpleChange = changes.device;
    this.device = device.currentValue;

    setTimeout(() => {
      this.updateData(); 
    });
  }

  fromDateChanged(event: MatDatepickerInputEvent<Date>) {
    Log.debug("fromDate: " + event.value);

    this.fromDate = event.value;

    if (this.fromDate >= this.toDate) {
      this.toDate.setDate(this.fromDate.getDate() + 1);  // adding 1 day
      this.toFormControl.setValue(this.toDate);
    }

    this.updateData();
  }

  toDateChanged(event: MatDatepickerInputEvent<Date>) {
    Log.debug("toDate: " + event.value);

    this.toDate = event.value;

    if (this.fromDate >= this.toDate) {
      this.fromDate.setDate(this.toDate.getDate() - 1);  // subtracting 1 day
      this.fromFormControl.setValue(this.fromDate);
    }

    this.updateData();
  }

  updateData() {

    if (!this.fromDate || !this.toDate || this.fromDate >= this.toDate) {
      this.errorMessage = "Le date inserite non sono valide";
      this.error = true;
      return;
    }

    this.error = false;

    if (this.device != null) {

      this.loader.showLoading();
      this.isLoading = true;

      this.dataSource = new AccessLogSource(this.accessLogService, this.device.serial, this.fromDate, this.toDate);
      this.table.dataSource = this.dataSource;

      this.dataSource.accessLogData.subscribe(data => {

        Log.debug("accessLogData: " + data);

        this.cdRef.detectChanges();
        
      }, error => {

        this.loader.hideLoading();
        this.loader.showError();
      });

      setTimeout(() => {
        
        this.dataSource.isLoading.subscribe(isLoading => {

          this.isLoading = isLoading;
          if (!isLoading) {
            this.loader.hideLoading();
          }
        });
      });
    }
  }

  reloadData(reload: boolean) {

    if (reload) {
      this.updateData();
    }
  }

}


export class AccessLogSource extends MatTableDataSource<AccessLog> {

  deviceSerial: string;
  isLoading = new BehaviorSubject(false);
  accessLogData = new BehaviorSubject<AccessLog[]>([]);
  fromDate: Date;
  toDate: Date;

  constructor(private accessLogService: AccessLogService, deviceSerial: string, fromDate: Date, toDate: Date) {
    super();
    this.deviceSerial = deviceSerial;

    this.fromDate = fromDate;
    this.toDate = toDate;
  }

  loadData() {

    Log.debug("AccessLogSource: loadData");

    this.isLoading.next(true);
    
    const obs = this.accessLogService.getAccessLogs(this.deviceSerial, this.fromDate, this.toDate, true);
    obs.subscribe(data => {

      this.isLoading.next(false);
      this.accessLogData.next(data);
    });
  }

  connect(): BehaviorSubject<AccessLog[]> {

    this.loadData();
    return this.accessLogData;
  }

  disconnect() {
  }
}
